"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateColors = void 0;
var theme_json_1 = __importDefault(require("./generated/theme.json"));
var aceEditor_1 = __importDefault(require("./component-styles/aceEditor"));
var button_1 = __importDefault(require("./component-styles/button"));
var colors_1 = __importDefault(require("./utils/colors"));
exports.generateColors = colors_1.default;
var utils_1 = require("../utils");
require("../utils/fonts");
var Sawmill = function (_a) {
    var colorScheme = _a.colorScheme, customColors = _a.customColors;
    var defaultColors = theme_json_1.default.colors[colorScheme];
    var colors = customColors ? (0, colors_1.default)(colorScheme, customColors) : defaultColors;
    var utils = {
        colorLevel: (0, utils_1.colorLevel)(colors.global.textDefault, colors.global.textAlt),
        readableColor: (0, utils_1.readableColor)(colors.global.textDefault, colors.global.textAlt),
        opacify: utils_1.opacify,
        contrastingColor: utils_1.contrastingColor,
    };
    return ({
        breakpoints: theme_json_1.default.breakpoints,
        components: customColors ? {
            aceEditor: (0, aceEditor_1.default)(colors),
            button: (0, button_1.default)(colors, utils),
        } : theme_json_1.default.components[colorScheme],
        colors: colors,
        fonts: theme_json_1.default.fonts,
        mode: colorScheme,
        spacings: theme_json_1.default.spacings,
        utils: utils,
    });
};
exports.default = Sawmill;
